import React, { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { TextInput, useTranslate, useNotify, BooleanInput, NumberInput } from 'react-admin'
import { Box, Button } from '@mui/material'
import { isInCheckedBoxList } from './helper'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'

export const CreateCustomVar = () => {
  const translate = useTranslate()
  const notify = useNotify()
  const { watch, resetField } = useFormContext()
  const { checkedBox, setCheckedBox } = useContext(CheckboxContext)
  const key = watch('varCustomKey')
  const value = watch('varCustomValue')
  const description = watch('varCustomDescription')
  const show = watch('varCustomShow')
  const showSitio = watch('varCustomShowSitio')

  const onClick = (key, value, show, showSitio, description) => {
    const newChecked = [...checkedBox]
    if (!isInCheckedBoxList(checkedBox, key)) {
      let item = {
        key,
        value: value ? value : 0,
        label: key,
        show: show,
        show_sitio: showSitio,
        global_variable: false,
        description: description,
        search: ['var', key, 'value'],
        created: true,
      }
      newChecked.push(item)
      setCheckedBox(newChecked)
      resetField('varCustomKey')
      resetField('varCustomValue')
      resetField('varCustomDescription')
      resetField('varCustomShow')
      resetField('varCustomShowSitio')
      return
    }
    notify('El nombre de la variable ya existe', { type: 'error' })
  }

  return (
    <Box>
      <Box>
        <EditInputsWrap label={translate('ra.field.name')}>
          <TextInput fullWidth source='varCustomKey' label='' />
        </EditInputsWrap>
        <EditInputsWrap label={translate('ra.field.description')}>
          <TextInput fullWidth source='varCustomDescription' label='' multiline rows={5} />
        </EditInputsWrap>
        <Box sx={{ display: 'flex' }}>
          <EditInputsWrap label={translate('ra.field.value')}>
            <NumberInput fullWidth source='varCustomValue' label='' />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.show_breakdown')}>
            <BooleanInput fullWidth source='varCustomShow' label='' />
          </EditInputsWrap>
          <EditInputsWrap label={translate('ra.field.show_sitio')}>
            <BooleanInput fullWidth source='varCustomShowSitio' label='' />
          </EditInputsWrap>
        </Box>
      </Box>

      <Button
        disabled={!key}
        onClick={() => onClick(key, value, show, showSitio, description)}
        style={{ height: '30px' }}
        size='small'
        variant='contained'
      >
        {translate('ra.action.create')}
      </Button>
    </Box>
  )
}
